module.exports = __webpack_public_path__ + "img/Mask备份@2x.8f1de3f3.png";